import React from 'react';
import useInView from './useInView';
import TypewriterTitle from './TypewriterTitle';

export default function ServiceBorehole() {
  const [contentRef, contentIn] = useInView();

  return (
    <div style={{ paddingTop: 'var(--nav-h)', overflowX: 'hidden', width: '100%', maxWidth: '100%' }}>
      {/* Hero */}
      <div style={{ height: '60vh', minHeight: 400, position: 'relative', display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
        <img src="https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=1800&q=85&fit=crop"
          alt="Borehole Drilling" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} />
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(105deg, rgba(10,22,40,0.85) 0%, rgba(10,22,40,0.4) 100%)' }} />
        <div className="section-wrap" style={{ position: 'relative', zIndex: 2 }}>
          <div className="section-label light">What We Do</div>
          <TypewriterTitle lines={['Borehole Drilling &', 'Water Engineering']} />
          <p style={{ fontSize: '1.1rem', color: 'rgba(255,255,255,0.75)', maxWidth: 560, marginTop: '1.5rem', lineHeight: 1.75 }}>
            Expert groundwater solutions from geophysical survey to full water supply systems — delivering clean water across Nigeria's communities.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <section style={{ padding: '6rem 0', background: 'white' }}>
        <div className="section-wrap">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '3rem', alignItems: 'start' }}>
            <div ref={contentRef} style={{ opacity: contentIn ? 1 : 0, transform: contentIn ? 'none' : 'translateY(30px)', transition: 'all 0.8s ease' }}>
              <div className="section-label">Our Expertise</div>
              <h2 className="section-title" style={{ marginBottom: '1.5rem' }}>Clean Water for<br /><span>Every Community</span></h2>
              <p style={{ fontSize: '1.05rem', lineHeight: 1.85, color: '#2a3a5c', marginBottom: '1.2rem' }}>
                Access to clean water is a fundamental right. Rigomich has drilled and commissioned boreholes for communities, schools, hospitals, and government facilities across Nigeria — bringing safe, reliable water to thousands of people.
              </p>
              <p style={{ fontSize: '1rem', lineHeight: 1.85, color: '#6b7fa8', marginBottom: '2rem' }}>
                Our water engineering team handles the complete process — from geophysical surveys to identify the best drilling sites, through to borehole construction, pump installation, and water treatment systems.
              </p>
              <a href="/#contact" className="btn-primary"><span>Request a Quote</span>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
              </a>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '1rem' }}>
              {[
                { img: '/projects/borehole-water.jpg', label: 'Borehole Drilling' },
                { img: 'https://images.unsplash.com/photo-1548407260-da850faa41e3?w=500&q=80&fit=crop', label: 'Water Treatment' },
                { img: 'https://images.unsplash.com/photo-1585771724684-38269d6639fd?w=500&q=80&fit=crop', label: 'Pump Installation' },
                { img: 'https://images.unsplash.com/photo-1519003722824-194d4455a60c?w=500&q=80&fit=crop', label: 'Water Supply' },
              ].map((item, i) => (
                <div key={i} style={{ position: 'relative', overflow: 'hidden', aspectRatio: '1' }}>
                  <img src={item.img} alt={item.label} style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.4s ease' }}
                    onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.06)'}
                    onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'} />
                  <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '0.8rem', background: 'linear-gradient(to top, rgba(10,22,40,0.9), transparent)' }}>
                    <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '0.75rem', fontWeight: 700, color: 'white', letterSpacing: '0.1em', textTransform: 'uppercase' }}>{item.label}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section style={{ padding: '5rem 0', background: '#0a1f5c' }}>
        <div className="section-wrap">
          <div className="section-label light" style={{ marginBottom: '1rem' }}>What We Offer</div>
          <h2 className="section-title light" style={{ marginBottom: '3rem' }}>Our <span>Services</span></h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '2px' }}>
            {[
              { title: 'Geophysical Survey & Siting', desc: 'Scientific ground surveys to identify optimal borehole locations and water table depth.' },
              { title: 'Borehole Drilling & Casing', desc: 'Professional drilling and casing installation using modern drill rigs.' },
              { title: 'Submersible & Solar Pumps', desc: 'Installation of submersible and solar-powered pumps for reliable water supply.' },
              { title: 'Water Treatment Plants', desc: 'Design and construction of water treatment facilities for communities and industries.' },
              { title: 'Overhead Tank Installation', desc: 'Elevated water storage tanks for reliable gravity-fed water distribution.' },
              { title: 'Borehole Rehabilitation', desc: 'Repair and rehabilitation of existing boreholes and water supply infrastructure.' },
            ].map((s, i) => (
              <div key={i} style={{ background: 'rgba(255,255,255,0.05)', padding: '2rem', borderBottom: '3px solid transparent', transition: 'all 0.3s', cursor: 'default' }}
                onMouseEnter={e => { e.currentTarget.style.background = 'rgba(26,79,156,0.3)'; e.currentTarget.style.borderBottomColor = '#7aaef0'; }}
                onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; e.currentTarget.style.borderBottomColor = 'transparent'; }}>
                <div style={{ width: 8, height: 8, background: '#7aaef0', marginBottom: '1rem' }} />
                <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, fontSize: '1rem', color: 'white', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.6rem' }}>{s.title}</div>
                <p style={{ fontSize: '0.88rem', color: 'rgba(255,255,255,0.7)', lineHeight: 1.7 }}>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ padding: '5rem 0', background: 'var(--off-white)', textAlign: 'center' }}>
        <div className="section-wrap">
          <h2 className="section-title" style={{ marginBottom: '1rem' }}>Ready to Start Your <span>Project?</span></h2>
          <p style={{ fontSize: '1.05rem', color: '#6b7fa8', marginBottom: '2rem' }}>Contact us today for a free consultation and project quote.</p>
          <a href="/#contact" className="btn-primary"><span>Get In Touch</span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
          </a>
        </div>
      </section>
    </div>
  );
}
